const BUBBLES = [
  { left: "30%", size: 16, delay: 0, dur: 4.4 },
  { left: "37%", size: 10, delay: 1.3, dur: 3.6 },
  { left: "46%", size: 20, delay: 0.5, dur: 5.2 },
  { left: "55%", size: 12, delay: 2.1, dur: 3.9 },
  { left: "63%", size: 17, delay: 0.9, dur: 4.8 },
  { left: "71%", size: 9, delay: 1.7, dur: 3.3 },
  { left: "52%", size: 7, delay: 2.8, dur: 3.1 },
];
const STEAM = [
  { left: "30%", delay: 0, dur: 5.5 },
  { left: "44%", delay: 1.8, dur: 6.2 },
  { left: "58%", delay: 0.9, dur: 5.8 },
  { left: "70%", delay: 2.6, dur: 6.5 },
];

export default function BathBreak({ mobileTop = false }) {
  return (
    <section className={`bg-transparent relative z-10 pb-0 ${mobileTop ? "-mb-[14%]" : "-mb-5 sm:-mb-9"}`} data-testid={mobileTop ? "bath-break-section-mobile" : "bath-break-section"}>
      <div className={`relative max-w-3xl mx-auto px-4 ${mobileTop ? "-mt-[4%]" : "-mt-[5%] sm:-mt-[6%] lg:-mt-[5%]"}`}>
        <div className="relative" data-testid="bath-tub">
          <img src="/tub.webp" alt="Happy Perth tradie enjoying a hot bubble bath" className="w-full h-auto" loading="lazy" decoding="async" />
          {STEAM.map((s, i) => (
            <span key={i} className="bath-steam" style={{ left: s.left, animationDelay: `${s.delay}s`, animationDuration: `${s.dur}s` }} data-testid={`heat-wave-${i}`} />
          ))}
          {BUBBLES.map((b, i) => (
            <span key={i} className="bath-bubble" style={{ left: b.left, width: b.size, height: b.size, animationDelay: `${b.delay}s`, animationDuration: `${b.dur}s` }} data-testid={`bath-bubble-${i}`} />
          ))}
          <span className="absolute duck-swim" style={{ left: "47%", top: "49.5%", width: "6.5%" }} data-testid="rubber-ducky">
            <img src="/ducky.webp" alt="" aria-hidden="true" className="w-full h-auto duck-bob" style={{ clipPath: "inset(0 0 26% 0)" }} />
          </span>
        </div>
      </div>
    </section>
  );
}
